module.exports = __webpack_public_path__ + "prod/1.42.2/img/h5BannerBgImg.09e72fa7.png";